module.exports = __webpack_public_path__ + "img/market.41966842.svg";